<nav class="navbar">
  <div class="container">
    <div class="navbar-content">

      <!-- 1. Logo - IZQUIERDA -->
      <div class="logo-container">
        <a routerLink="/" class="logo-link">
          <img src="assets/img/logos/main_logo.svg" class="logo-img" alt="LightCap Group"
            onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';" />

          <div class="logo-text-fallback" style="display: none;">
            <span class="logo-light">LightCap</span><span class="logo-divider">|</span><span
              class="logo-group">Group</span>
          </div>
        </a>
      </div>

      <!-- 2. Desktop Menu - DERECHA -->
      <div class="desktop-menu">
        @for(menu of menus; track menu.label) {
        @if(menu.showOnDesktop !== false) {
        @if(menu.child && menu.child.length > 0) {
        <div class="dropdown">
          <button class="menu-btn" type="button" (click)="toggleDesktopMenu(menu.label)"
            [attr.aria-expanded]="desktopMenuOpen === menu.label">
            {{ menu.label }}
            <i class="fas fa-chevron-down chevron" [class.open]="desktopMenuOpen === menu.label"></i>
          </button>

          @if (desktopMenuOpen === menu.label) {
          <div class="dropdown-menu">
            @for(child of menu.child; track child.label) {
            <a [routerLink]="child.path" class="dropdown-item" (click)="desktopMenuOpen = null">
              {{ child.label }}
            </a>
            }
          </div>
          }
        </div>
        } @else {
        <a [routerLink]="menu.path" class="menu-link">
          {{ menu.label }}
        </a>
        }
        }
        }
      </div>

      <!-- 3. Hamburguesa - DERECHA (solo móvil) -->
      <button class="hamburger-btn" (click)="mobileMenuOpen = !mobileMenuOpen" aria-label="Abrir menú">
        <span class="hamburger-icon" [class.open]="mobileMenuOpen">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>

    </div>
  </div>

  <!-- Mobile Menu -->
  @if(mobileMenuOpen) {
  <div class="mobile-menu">
    <div class="mobile-menu-content">
      @for(menu of menus; track menu.label) {
      @if(menu.showOnMobile || isMobileView) {
      @if(menu.child && menu.child.length > 0) {
      <div class="mobile-dropdown">

        <!-- 1. Hacemos que el título sea un botón interactivo -->
        <div class="mobile-dropdown-title" style="display: flex; justify-content: space-between; cursor: pointer;"
          (click)="mobileSubmenuOpen = mobileSubmenuOpen === menu.label ? null : menu.label">
          {{ menu.label }}
          <i class="fas fa-chevron-down chevron" [class.open]="mobileSubmenuOpen === menu.label"></i>
        </div>

        <!-- 2. Envolvemos los items en un @if -->
        @if(mobileSubmenuOpen === menu.label) {
        <div class="mobile-dropdown-items">
          @for(child of menu.child; track child.label) {
          @if(child.showOnMobile !== false) {
          <a [routerLink]="child.path" (click)="mobileMenuOpen = false" class="mobile-link">
            {{ child.label }}
          </a>
          }
          }
        </div>
        }

      </div>
      } @else {
      <a [routerLink]="menu.path" (click)="mobileMenuOpen = false" class="mobile-link">
        {{ menu.label }}
      </a>
      }
      }
      }
    </div>
  </div>
  }
</nav>